/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/personGroupPersonMappers";
import * as Parameters from "../models/parameters";
/** Class representing a PersonGroupPerson. */
var PersonGroupPerson = /** @class */ (function () {
    /**
     * Create a PersonGroupPerson.
     * @param {FaceClientContext} client Reference to the service client.
     */
    function PersonGroupPerson(client) {
        this.client = client;
    }
    PersonGroupPerson.prototype.create = function (personGroupId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            options: options
        }, createOperationSpec, callback);
    };
    PersonGroupPerson.prototype.list = function (personGroupId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            options: options
        }, listOperationSpec, callback);
    };
    PersonGroupPerson.prototype.deleteMethod = function (personGroupId, personId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            personId: personId,
            options: options
        }, deleteMethodOperationSpec, callback);
    };
    PersonGroupPerson.prototype.get = function (personGroupId, personId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            personId: personId,
            options: options
        }, getOperationSpec, callback);
    };
    PersonGroupPerson.prototype.update = function (personGroupId, personId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            personId: personId,
            options: options
        }, updateOperationSpec, callback);
    };
    PersonGroupPerson.prototype.deleteFace = function (personGroupId, personId, persistedFaceId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            personId: personId,
            persistedFaceId: persistedFaceId,
            options: options
        }, deleteFaceOperationSpec, callback);
    };
    PersonGroupPerson.prototype.getFace = function (personGroupId, personId, persistedFaceId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            personId: personId,
            persistedFaceId: persistedFaceId,
            options: options
        }, getFaceOperationSpec, callback);
    };
    PersonGroupPerson.prototype.updateFace = function (personGroupId, personId, persistedFaceId, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            personId: personId,
            persistedFaceId: persistedFaceId,
            options: options
        }, updateFaceOperationSpec, callback);
    };
    PersonGroupPerson.prototype.addFaceFromUrl = function (personGroupId, personId, url, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            personId: personId,
            url: url,
            options: options
        }, addFaceFromUrlOperationSpec, callback);
    };
    PersonGroupPerson.prototype.addFaceFromStream = function (personGroupId, personId, image, options, callback) {
        return this.client.sendOperationRequest({
            personGroupId: personGroupId,
            personId: personId,
            image: image,
            options: options
        }, addFaceFromStreamOperationSpec, callback);
    };
    return PersonGroupPerson;
}());
export { PersonGroupPerson };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var createOperationSpec = {
    httpMethod: "POST",
    path: "persongroups/{personGroupId}/persons",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId
    ],
    requestBody: {
        parameterPath: {
            name: [
                "options",
                "name"
            ],
            userData: [
                "options",
                "userData"
            ]
        },
        mapper: __assign(__assign({}, Mappers.NameAndUserDataContract), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.Person
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var listOperationSpec = {
    httpMethod: "GET",
    path: "persongroups/{personGroupId}/persons",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId
    ],
    queryParameters: [
        Parameters.start0,
        Parameters.top0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "Person"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var deleteMethodOperationSpec = {
    httpMethod: "DELETE",
    path: "persongroups/{personGroupId}/persons/{personId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId,
        Parameters.personId
    ],
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var getOperationSpec = {
    httpMethod: "GET",
    path: "persongroups/{personGroupId}/persons/{personId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId,
        Parameters.personId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.Person
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var updateOperationSpec = {
    httpMethod: "PATCH",
    path: "persongroups/{personGroupId}/persons/{personId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId,
        Parameters.personId
    ],
    requestBody: {
        parameterPath: {
            name: [
                "options",
                "name"
            ],
            userData: [
                "options",
                "userData"
            ]
        },
        mapper: __assign(__assign({}, Mappers.NameAndUserDataContract), { required: true })
    },
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var deleteFaceOperationSpec = {
    httpMethod: "DELETE",
    path: "persongroups/{personGroupId}/persons/{personId}/persistedfaces/{persistedFaceId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId,
        Parameters.personId,
        Parameters.persistedFaceId
    ],
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var getFaceOperationSpec = {
    httpMethod: "GET",
    path: "persongroups/{personGroupId}/persons/{personId}/persistedfaces/{persistedFaceId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId,
        Parameters.personId,
        Parameters.persistedFaceId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.PersistedFace
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var updateFaceOperationSpec = {
    httpMethod: "PATCH",
    path: "persongroups/{personGroupId}/persons/{personId}/persistedfaces/{persistedFaceId}",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId,
        Parameters.personId,
        Parameters.persistedFaceId
    ],
    requestBody: {
        parameterPath: {
            userData: [
                "options",
                "userData"
            ]
        },
        mapper: __assign(__assign({}, Mappers.UpdateFaceRequest), { required: true })
    },
    responses: {
        200: {},
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var addFaceFromUrlOperationSpec = {
    httpMethod: "POST",
    path: "persongroups/{personGroupId}/persons/{personId}/persistedfaces",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId,
        Parameters.personId
    ],
    queryParameters: [
        Parameters.userData,
        Parameters.targetFace,
        Parameters.detectionModel
    ],
    requestBody: {
        parameterPath: {
            url: "url"
        },
        mapper: __assign(__assign({}, Mappers.ImageUrl), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.PersistedFace
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
var addFaceFromStreamOperationSpec = {
    httpMethod: "POST",
    path: "persongroups/{personGroupId}/persons/{personId}/persistedfaces",
    urlParameters: [
        Parameters.endpoint,
        Parameters.personGroupId,
        Parameters.personId
    ],
    queryParameters: [
        Parameters.userData,
        Parameters.targetFace,
        Parameters.detectionModel
    ],
    requestBody: {
        parameterPath: "image",
        mapper: {
            required: true,
            serializedName: "Image",
            type: {
                name: "Stream"
            }
        }
    },
    contentType: "application/octet-stream",
    responses: {
        200: {
            bodyMapper: Mappers.PersistedFace
        },
        default: {
            bodyMapper: Mappers.APIError
        }
    },
    serializer: serializer
};
//# sourceMappingURL=personGroupPerson.js.map